import {Text} from '@mantine/core';

const PLACEHOLDER = '—';

// Long ids (account, customer, meter key) in monospace so they are scannable and
// comparable at a glance (§13). An absent value renders the placeholder, never blank.
export const MonoText = ({value, size = 'xs'}: { value?: string | null, size?: 'xs' | 'sm' }) =>
    value ? <Text size={size} ff='monospace'>{value}</Text> : <>{PLACEHOLDER}</>;
